import { useState, useCallback } from "react";
import logger from "../utils/logger";

export default function useFocus(api, setUser) {
  const [focusActive, setFocusActive] = useState(false);
  const [focusSessionId, setFocusSessionId] = useState(null);
  const [achievementsData, setAchievementsData] = useState({ definitions: [], unlocked: [], focus_streak: 0, focus_sessions: 0 });

  const fetchAchievements = useCallback(async () => {
    try { const r = await api.get("/achievements"); setAchievementsData(r.data); }
    catch (e) { logger.error("Fetch achievements:", e); }
  }, [api]);

  const startFocus = useCallback(async () => {
    try {
      const r = await api.post("/focus/start");
      setFocusSessionId(r.data.session_id);
      setFocusActive(true);
    } catch (e) { logger.error("Start focus:", e); }
  }, [api]);

  const endFocus = useCallback(async () => {
    if (!focusSessionId) return;
    try {
      await api.post(`/focus/end/${focusSessionId}`);
      setFocusActive(false);
      setFocusSessionId(null);
      const [userRes, achRes] = await Promise.all([api.get("/auth/me"), api.get("/achievements")]);
      setUser(userRes.data);
      setAchievementsData(achRes.data);
    } catch (e) { logger.error("End focus:", e); }
  }, [api, focusSessionId, setUser]);

  return { focusActive, achievementsData, fetchAchievements, startFocus, endFocus };
}
